import { Action } from 'redux';

import { isFetchStartersInfoRequestedAction, isFetchStartersSucceededAction } from '../actions/StartersActions';
import { StartersState } from '../types/StartersTypes';

const defaultStarterState: StartersState = {
  starters: [],
  isBusy: false,
};

export function starterReducer(previousState: StartersState = defaultStarterState, action: Action): StartersState {
  if (isFetchStartersInfoRequestedAction(action)) {
    return ({
      starters: action.starters,
      isBusy: true,
    });
  }
  if (isFetchStartersSucceededAction(action)) {
    return ({
      starters: action.starters,
      isBusy: false,
    });
  }

  return previousState;
}
